<template>
    <div>
        <el-form ref="queryParams" inline label-position="right" label-width="120px" v-model="queryParams">
            <el-form-item>
                <el-button size="small" @click="queryParams.year=0;" :type="queryParams.year==0?'success':'default'" >今年</el-button> <el-button size="small" :type="queryParams.year==-1?'success':'default'" @click="queryParams.year=-1;search();">去年</el-button>
            </el-form-item>
            <el-form-item label="仓库">
                <el-select v-model="queryParams.warehouseId" @on-change="warehouseChange" style="width: 160px">
                    <el-option :value="warehouse.id" v-for="warehouse in warehouses" :key="warehouse.id">{{warehouse.name}}</el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button size="small" v-on:click="search()" type="primary" :loading="loading">搜索</el-button>
                <el-button size="small" v-on:click="reset()">重置</el-button>
            </el-form-item>
        </el-form>
        <Table :loading="loading" :columns="columns" :data="merchants" border>
        </Table>
    </div>
</template>
<script>
export default {
    name: 'Payment',
    data() {
        return {
            loading: false,
            merchants: [],
            warehouses: [],
            queryParams: {

                year: 0
            },

            page: {
                total: 0,
                current: 1,
                pageSize: 10
            },
            rules: {},
            columns: [{
                    title: '时间',
                    key: 'time',

                    align: 'center',
                    render: (h, params) => {
                        var me = this;
                        return h("div", [
                            h("span", { style: {} }, me.long2month(params.row.time))
                        ]);
                    }
                }, {
                    title: '订单出库',
                    key: 'todayOutgoing',
                    width: 260,
                    align: 'center',
                    render: (h, params) => {
                        var me = this;
                        return h("div", [


                            h("div", { style: {}, class: { tips: true } }, params.row.todayOutgoing)
                        ]);
                    }
                }, {
                    title: '订单新增',
                    key: 'todayCreate',
                    width: 260,
                    align: 'center',
                    render: (h, params) => {
                        var me = this;
                        return h("div", [


                            h("div", { style: {}, class: { tips: true } }, params.row.todayCreate)
                        ]);
                    }
                }, {
                    title: '包裹签收',
                    key: 'todaySign',
                    width: 260,
                    align: 'center',
                    render: (h, params) => {
                        var me = this;
                        return h("div", [


                            h("div", { style: {}, class: { tips: true } }, params.row.todaySign)
                        ]);
                    }
                }, {
                    title: '包裹新增',
                    key: 'todayPackageCreate',
                    width: 260,
                    align: 'center',
                    render: (h, params) => {
                        var me = this;
                        return h("div", [


                            h("div", { style: {}, class: { tips: true } }, params.row.todayPackageCreate)
                        ]);
                    }
                }

            ]
        };
    },
    mounted: function() {

        this.getWarehouses();
    },
    methods: {
        getWarehouses: function() {
            var me = this;
            me.loading = true;
            me.$http.post("/ware/warehouse/getall.action", {}).then(response => {
                var body = response;
                if (body.status == 0) {

                    me.warehouses = body.obj;
                    if (me.warehouses.length > 0) {
                        me.queryParams.warehouseId = me.warehouses[0].id;
                        me.getList();
                    }

                }
                me.loading = false;
            }, response => {
                me.loading = false;
            });
        },
        cbtime: function(value) {
            this.queryParams.btime = value;
            if (this.queryParams.warehouseId) this.search();
        },
        warehouseChange() {
            if (this.queryParams.btime) this.search();
        },

        search: function() {
            this.page.current = 1;
            this.page.total = 0;
            this.getList();
        },

        reset: function() {
            this.others.btime = this.long2date(new Date().getTime() / 1000);
            this.queryParams.btime = this.others.btime;
            this.merchants = [];
            this.getList();
        },

        changePage(current) {
            this.page.current = current;
            this.getList();
        },
        getList: function() {
            var me = this;

            if (!me.queryParams.warehouseId) {
                me.errorMessage("请先选择好仓库");
                return;
            }
            var params = me.queryParams;
            params.current = me.page.current;
            params.pageSize = me.page.pageSize;
            me.loading = true;
            me.$http.post("/ware/stastis/waybillmonthreport.action", params).then(response => {
                var body = response;
                if (body.status == 0) {

                    me.merchants = body.obj;

                }
                me.loading = false;
            }, response => {
                me.loading = false;
            });
        }
    }
}
</script>
<style scoped>
.tips {
    color: #ff9900;
    font-size: 16px;
    margin-left: 10px;
}

.tips.success {
    color: #19be6b
}

.tips.error {
    color: #ed4014
}

.tips.info {
    color: #2db7f5
}
</style>